<div class="d-block w-100">
  <ul class="list-unstyled" id="searchFields">
    <li>
      <div class="tab w-100">
        <a #firstName
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == firstName.id}"
          id="firstName">
          First&nbsp;Name <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #lastName
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == lastName.id}"
          id="lastName">
          Last&nbsp;Name <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #emailAddress
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == emailAddress.id}"
          id="emailAddress">
          Email <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #mobileNo
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == mobileNo.id}"
          id="mobileNo">
          Mobile <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #userRole
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == userRole.id}"
          id="userRole">
          Role <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #status (click)="getTabContent($event)" [ngClass]="{'active':activeTab == status.id}" id="status">
          Status <em class="dropdown-toggle" style="float: right"></em>
        </a>
      </div>
      <form [formGroup]="form">
        <div>
          @switch (activeTab) {
            @case (firstName.id) {
              <div class="tabcontent">
                <input (input)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="name"
                  id="name"
                  placeholder="User Name"
                  type="text"/>
              </div>
            }
            @case (lastName.id) {
              <div class="tabcontent">
                <input (input)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="surname"
                  id="surname"
                  placeholder="User Lastname"
                  type="text"/>
              </div>
            }
            @case (emailAddress.id) {
              <div class="tabcontent">
                <input (input)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="email"
                  id="email"
                  placeholder="Email"
                  type="text"/>
              </div>
            }
            @case (mobileNo.id) {
              <div class="tabcontent">
                <input (input)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="mobile"
                  id="mobile"
                  placeholder="Mobile"
                  type="tel"/>
              </div>
            }
            @case (userRole.id) {
              <div class="tabcontent">
                <p-select [options]="roleOptions"
                  class="form-control"
                  formControlName="role"
                  id="role"
                  optionLabel="label"
                optionValue="value"></p-select>
              </div>
            }
            @case (status.id) {
              <div class="tabcontent">
                <p-select [options]="statusOptions"
                  class="form-control"
                  formControlName="userStatus"
                  id="userStatus"
                  optionLabel="label"
                optionValue="value"></p-select>
              </div>
            }
          }
        </div>
        <div class="row">
          <div [hidden]="!tabActive" class="col-md-12 text-center">
            <button (click)="clear(activeTab)"
              [disabled]="disableClear(activeTab)"
              class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
              type="button">
              Clear
            </button>
            <button (click)="clearAll()"
              [disabled]="disableClearAll()"
              class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
              type="button">
              Clear All
            </button>
            <button (click)="search()"
              class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
              type="submit">
              Update
            </button>
          </div>
        </div>
      </form>
    </li>
  </ul>
</div>